export const GLOBALS = {};